import { AvailableLocale } from '@/types/global'

/**
 * Shared locale configuration.
 *
 * Deliberately free of next-intl (and any other) imports so it can be consumed from client
 * components, server modules, middleware and plain utilities alike without dragging the
 * navigation runtime along with it.
 */

// @TODO: add vi support
// export const locales = ['en', 'ja', 'vi']
export const locales = ['en', 'ja']

// Used when no locale matches.
export const defaultLocale: AvailableLocale = 'en'
